<template>
  <el-form :model="loginForm" :rules="rules" ref="loginForm" label-position="left" label-width="0px" class="demo-ruleForm login-container">
    <h3 class="title">License Host Server Login</h3>
    <el-form-item prop="account">
      <el-input type="text" v-model="loginForm.account" auto-complete="off" placeholder="Account"></el-input>
    </el-form-item>
    <el-form-item prop="checkPass">
      <el-input type="password" v-model="loginForm.checkPass" auto-complete="off" placeholder="Password"
                @keyup.enter.native="login"></el-input>
    </el-form-item>
    <!--<el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>-->
    <el-form-item style="width:100%;">
      <el-button type="success" plain style="width:100%;" @click.native.prevent="login" :loading="logging_in">Login</el-button>
    </el-form-item>
    <el-form-item v-show="login_fail">
     <h3 style="color:red">Login Fail. Please Try Again</h3>
    </el-form-item>
  </el-form>
</template>

<script>
import { requestLogin } from '../api'
import * as Base64 from 'js-base64'
import * as types from '../store/types'
export default {
  name: 'Login',
  data () {
    return {
      logging_in: false,
      login_fail: false,
      loginForm: {
        account: '',
        checkPass: ''
      },
      rules: {
        account: [
          { required: true, message: 'Please Enter Account', trigger: 'blur' }
        ],
        checkPass: [
          { required: true, message: 'Please Enter Password', trigger: 'blur' }
        ]
      },
      checked: true
    }
  },
  methods: {
    login () {
      let that = this
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          that.logging_in = true
          let encoded = Base64.encode(this.loginForm.account + ':' + this.loginForm.checkPass)
          that.$store.commit(types.LOGIN, encoded)

          requestLogin().then(data => {
            that.logging_in = false
            that.login_fail = false
            that.$store.commit(types.LOGIN_STATE, true)
            that.$store.commit(types.LOGIN_NAME, data.login_name)
            that.$store.commit(types.LOGIN, data.access_token)
            that.$store.commit(types.USERTYPE, data.user_type)
            that.$router.push({ path: '/welcome' })
          }).catch(error => {
            if (error) {
              console.log(error.stack)
            }
            that.logging_in = false
            that.login_fail = true
            that.$store.commit(types.LOGIN, null)
          })
        } else {
          that.logging_in = false
          that.login_fail = true
          console.log('error login!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
  .login-container {
      /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
      -webkit-border-radius: 5px;
      border-radius: 5px;
      -moz-border-radius: 5px;
      background-clip: padding-box;
      margin: 180px auto;
      width: 350px;
      padding: 35px 35px 15px 35px;
      background: #fff;
      border: 1px solid #eaeaea;
      box-shadow: 0 0 25px #cac6c6;
    }
    .title {
      margin: 0 auto 40px auto;
      text-align: center;
      color: #505458;
    }
</style>



// WEBPACK FOOTER //
// Login.vue?36697da7